import React from "react";
import { Link } from "react-router";
import moment from "moment";
import API from "../base/API";
import { translate } from "../base/Translation";

export default class NotificationWidget extends React.Component {
    constructor(props) {
        super(props);

        this.api = new API({
            get_notifications: "/notification/fetch/all?limit_from=:from&limit_max=:to"
        });

        this.state = {
            notifications: [],
            title: translate("Notifikácie"),
            viewAllButtonText: translate("Zobraziť všetky"),
            interval: null,
            loading: false,
            limit_from: 0,
            limit_to: 5
        }
    }

    fetchData() {
        this.setState({ loading: true });

        this.api.request({
            cache: true,
            route: "get_notifications",
            params: { from: this.state.limit_from, to: this.state.limit_to },
            success: (response) => {
                this.setState({ notifications: response, loading: false });
            }
        });
    }

    componentDidMount() {
        this.fetchData();

       /*let interval = setInterval(function () {
            this.fetchData();
        }.bind(this), 2000);

        this.setState({ interval: interval });*/
    }

    componentWillUnmount() {
        clearInterval(this.state.interval);
    }

    renderList() {
        return this.state.notifications.map(function (notification) {
            return (
                <tr key={notification.id} className={"color-" + notification.type}>
                    <td>
                        <div>
                            <div className="pull-left">
                                <b>{notification.user.name}</b>
                            </div>
                            <div className="pull-right">
                                <small>{moment(notification.created.date).format("D.M.Y H:m:s")}</small>
                            </div>
                            <div className="clearfix" />
                            <div className="pull-left"> {notification.content}</div>
                        </div>
                    </td>
                </tr>
            )
        });
    }

    render() {
        return (
            <div className="panel panel-default">
                <div className="panel-heading">
                    <h3 className="panel-title">
                        <i className="fa fa-globe fa-fw">&nbsp;</i> {this.state.title}
                        <span className="pull-right loading-small">{this.state.loading ? translate("Načítavam...") : ""}</span>
                    </h3>
                </div>
                <div className="panel-body">
                    <table className="table table-responsive table-hover">
                        <tbody>
                            {this.renderList()}
                        </tbody>
                    </table>
                    <div className="text-right">
                        <Link to="/notification/list">{this.state.viewAllButtonText}&nbsp;
                                <i className="fa fa-arrow-circle-right">&nbsp;</i>
                        </Link>
                    </div>
                </div>
            </div>
        )
    }


}


// WEBPACK FOOTER //
// ./src/modules/notification/NotificationWidget.js